import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

const dotenv = require("dotenv");

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const category = [
  "Climate Resilience",
  "Secondary Cities",
  "Artificial Intelligence",
  "Innovation Ecosystem",
  "Others",
];

const WaitingForm = () => {
  dotenv.config();

  const [values, setValues] = React.useState({
    status: "",
  });

  const handleChange = (e) => {
    setValues({
      ...values,
      status: e.target.value,
    });
  };

  const [categoryList, setCategoryList] = React.useState([]);

  const handleCatChange = (event) => {
    const {
      target: { value },
    } = event;
    setCategoryList(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY,
      )
      .then(
        (result) => {
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Ooops, something went wrong",
            text: error.text,
          });
        },
      );
    e.target.reset();
    setValues("");
  };

  const ColorButton = styled(Button)(() => ({
    color: "#fff",
    width: 220,
    height: 65,
    fontWeight: 700,
    fontSize: "18px",
    textTransform: "capitalize",
    borderRadius: "30px",
    backgroundColor: "#39484E",
    border: "2px solid #39484E",
    "&:hover": {
      color: "#39484E",
      backgroundColor: "#F6F4F0",
      borderColor: "#F6F4F0",
    },
  }));

  return (
    <Box margin={{ xs: "25% 0%", sm: "5% 0%" }}>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"1%"}
      >
        Join the AIRFund waiting list
      </Typography>
      <Box
        width={"100%"}
        margin={{ xs: "5% 0%", sm: "2% 0% 2% 0%" }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "68%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Fullname
                </Typography>
                <TextField
                  placeholder="Name *"
                  variant="outlined"
                  name={"name"}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Email Address
                </Typography>
                <TextField
                  required
                  placeholder="Email *"
                  variant="outlined"
                  name={"email"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Phone Number
                </Typography>
                <TextField
                  required
                  placeholder="Phone Number *"
                  variant="outlined"
                  name={"phone"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Organization
                </Typography>
                <TextField
                  required
                  placeholder="Organization *"
                  variant="outlined"
                  name={"organization"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Status
                </Typography>
                <FormControl required fullWidth>
                  <Select
                    labelId="status"
                    id="status"
                    placeholder="Status"
                    name={"status"}
                    fullWidth
                    value={values.status}
                    onChange={handleChange}
                  >
                    <MenuItem value={"Early Stage"}>Early Stage</MenuItem>
                    <MenuItem value={"Growth Stage"}>Growth Stage</MenuItem>
                    <MenuItem value={"Scaling Stage"}>Scaling Stage</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Categories
                </Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    fullWidth
                    value={categoryList}
                    onChange={handleCatChange}
                    input={<OutlinedInput label="Categories" />}
                    MenuProps={MenuProps}
                  >
                    {category.map((name) => (
                      <MenuItem
                        key={name}
                        value={name}
                        // style={getStyles(name, personName, theme)}
                      >
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Funding
                </Typography>
                <FormControl required fullWidth>
                  <Select
                    labelId="funding"
                    id="funding"
                    placeholder="Funding"
                    name={"funding"}
                    fullWidth
                    value={values.status}
                    onChange={handleChange}
                  >
                    <MenuItem value={"Grant"}>Grant</MenuItem>
                    <MenuItem value={"Equity"}>Equity</MenuItem>
                    <MenuItem value={"Hybrid"}>Hybrid</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Country
                </Typography>
                <FormControl required fullWidth>
                  <Select
                    labelId="country"
                    id="country"
                    placeholder="Country"
                    name={"country"}
                    fullWidth
                    value={values.status}
                    onChange={handleChange}
                  >
                    <MenuItem value={"Grant"}>Grant</MenuItem>
                    <MenuItem value={"Equity"}>Equity</MenuItem>
                    <MenuItem value={"Hybrid"}>Hybrid</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography variant={"subtitle2"} sx={{ marginBottom: 1 }}>
                  Initiative
                </Typography>
                <TextField
                  required
                  placeholder="Initiative *"
                  variant="outlined"
                  name={"initiative"}
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box width={"100%"}>
                  <ColorButton
                    size={"large"}
                    variant={"contained"}
                    type={"submit"}
                  >
                    Submit
                  </ColorButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default WaitingForm;
